const classInfo = [
  { 
    className: "Warrior",
    jobs: [
      {
        jobName: "Hero",
        jobNameKey: "hero",
        jobDescription: "This class mainly uses swords and axes, and possesses significant attack power. While attacking, you'll gain combo orbs, which can inflict great damage once fully charged.",
        ability: ["Raging Blow", "Burning Soul Blade"]
      },
      {
        jobName: "Paladin",
        jobNameKey: "paladin",
        jobDescription: "This class utilizes Holy Power skills to increase its Attack Power and reduce damage taken. It can also conjure a hammer from pure light.",
        ability: ["Divine Charge", "Smite Shield"]
      },
      {
        jobName: "Dark Knight",
        jobNameKey: "dark-knight",
        jobDescription: "This class specializes in spears and polearms, weapons with a long reach. It also summons the Evil Eye, a messenger of darkness, which can be used in various ways in battle. The contract with darkness allows a Dark Knight to ignore death, even after reaching 0 HP, and punish enemies for their insolence.",
        ability: ["Evil Eye", "Nightshade Explosion"]
      },
    ]
  },
  { 
    className: "Magician",
    jobs: [
      {
        jobName: "Archmage - Fire/Poison",
        jobNameKey: "archmage-firepoison",
        jobDescription: "This class specializes in Fire and Poison magic. Most attack skills inflict Damage over Time (DoT), and the attacks become stronger the more damage over time is inflicted.",
        ability: ["Creeping Toxin", "Ifrit"]
      },
      {
        jobName: "Archmage - Ice/Lightning",
        jobNameKey: "archmage-icelightning",
        jobDescription: "This class specializes in lightning and ice magic. Ice attacks have a Freezing effect. Attacking with a powerful lightning magic, on an enemy that has Freezing effect stacks, will inflict even more damage.",
        ability: ["Chain Lightning", "Elquines"]
      },
      {
        jobName: "Bishop",
        jobNameKey: "bishop",
        jobDescription: "This class has beneficial skills that heal and support allies, such as the Angel of Benevolence. Conversely, the Angel of Benevolence can turn into the Avenging Angel, with skills specialized for attack.",
        ability: ["Righteously Indignant", "Bahamut"]
      },
    ]
  },
  { 
    className: "Bowman",
    jobs: [
      {
        jobName: "Bowmaster",
        jobNameKey: "bowmaster",
        jobDescription: "This class specializes in using bows for long-ranged attacks. It also carries special arrowheads, which can be swapped out according to the situation. With its rapid-fire archery, which often leaves an afterimage, this class keeps enemies pinned down nonstop.",
        ability: ["Speed Mirage", "Gritty Gust"]
      },
      {
        jobName: "Marksman",
        jobNameKey: "marksman",
        jobDescription: "This class specializes in using crossbows for long-ranged attacks. Each time you fire a certain number of shots, the next shot fills with powerful energy.",
        ability: ["Empowered Arrow", "High Speed Shot"]
      },
    ]
  },
  { 
    className: "Thief",
    jobs: [
      {
        jobName: "Night Lord",
        jobNameKey: "nightlord",
        jobDescription: "This class specializes in showering enemies with throwing stars from long range. More than that, many of the stars are imbued with magical talismans, which can attack enemies over a wide area.",
        ability: ["Showdown", "Death Star"]
      },
      {
        jobName: "Shadower",
        jobNameKey: "shadower",
        jobDescription: "This class wields daggers, hiding behind a smokescreen or in the shadows before assassinating enemies with deadly consecutive attacks. Uses various skills in conjunction with Mesos, representing luck.",
        ability: ["Meso Explosion", "Shadow Shifter"]
      },
      {
        jobName: "Dual Blade",
        jobNameKey: "dual-blade",
        jobDescription: "This class is a member of the Secret Garden, a secretive organization, which uses a pair of bladed weapons for flurries of devastating attacks.",
        ability: ["Phantom Blow", "Flashbang"]
      },
    ]
  },
  { 
    className: "Pirate",
    jobs: [
      {
        jobName: "Corsair",
        jobNameKey: "corsair",
        jobDescription: "This class fires barrages of bullets. It can also summon the brave crewmen and weapons of the Nautilus for various types of attacks.",
        ability: ["Broadside", "Ugly Bomb"]
      },
      {
        jobName: "Buccaneer",
        jobNameKey: "buccaneer",
        jobDescription: "This class uses knuckle-based fighting techniques to suppress enemies. With the power of the Sea Serpent, which materializes automatically when using fighting skills, it can deal additional attacks",
        ability: ["Sea Serpent", "Octopunch"]
      },
      {
        jobName: "Cannoneer",
        jobNameKey: "cannoneer",
        jobDescription: "This class wields Hand Cannons to launch powerful long-range attacks. It also comes complete with a monkey, who assists with heavy bombing attacks.",
        ability: ["Monkey Mortar", "Rolling Rainbow"]
      },
    ]
  },
];

export default classInfo;